<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'banner管理'}]" :title="'banner管理'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="门户" name="0"></el-tab-pane>
              <el-tab-pane label="移动端" name="1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                
                <div class="right">
                    <el-button type="primary" size="small" icon="el-icon-plus"
					@click="edit()"
					v-if="authorities.indexOf('sys:permission:background:banner:config:list:button:sort')!=-1" 
					>发布banner</el-button>
                </div>
                <div class="left">
                    <div class="child">
                        <span class="name">banne列表(最多9条）</span>
                    </div>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    
					v-if="authorities.indexOf('sys:permission:background:banner:config:list:button:sort')!=-1" 
                    label="排序">
                    <template slot-scope="scope">
                        <div class="elrow">
                            <i class="el-icon-top" v-if="scope.$index != 0" @click="moveDown(scope.row,0)"></i>
                            <i class="el-icon-bottom" v-if="scope.$index != tableData.length - 1" @click="moveDown(scope.row,1)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    show-overflow-tooltip
                    
                    label="排序">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="图片">
                    <template slot-scope="scope">
                        <div class="tableName" @click="preview(scope.row)">{{scope.row.bannerImgUrl}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="bannerName"
                    show-overflow-tooltip
                    
                    label="banner名称">
                </el-table-column>
                <el-table-column
                    prop="linkUrl"
                    show-overflow-tooltip
                    
                    label="链接">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="发布人">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="modifyName"
                    show-overflow-tooltip
                    
                    label="更新人">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    label="更新时间">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:banner:config:list:button:edit')!=-1 ||
                   authorities.indexOf('sys:permission:background:banner:config:list:button:delete')!=-1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain
						v-if="authorities.indexOf('sys:permission:background:banner:config:list:button:edit')!=-1" 
						@click="edit(scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" class="super" plain
						 v-if="authorities.indexOf('sys:permission:background:banner:config:list:button:delete')!=-1"
						@click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 预览弹出层 -->
            <el-dialog :visible.sync="dialogVisible" title="图片预览">
                <img style="max-width:100%" :src="logoPic">
            </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
          tab:'0',
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            tableData:[],//表格数据
            dialogVisible:false,//预览弹出层
            move:{
                id:'',
                move:''
            },
            logoPic:""
        }
    },
    created(){
        this.init()
    },
    mounted(){
      const that = this
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    methods:{
      changeTab: function (tab) {
                // const num = tab.name
                this.tab = tab.name
                // this.getSelect = '';//检索下拉的值
                // this.getValue = '';//检索输入框的值
                // this.dateS = [];//日期
                // this.sendInfoOne.currentPage = 1;//页码
                // this.sendInfoOne.pageSize = 20;//条数
                // this.sendInfoOne.reviewResult = null;//审核结果
                // this.sendInfoOne.startTime = null;//开始时间
                // this.sendInfoOne.endTime = null;//结束时间
                // this.sendInfoOne.id = null;//申请id
                // this.sendInfoOne.userName = null;//账号
                // this.sendInfoOne.realName = null;//姓名
                // this.sendInfoOne.property = null;//排序字段
                // this.sendInfoOne.direction = null;//排序方式
                // this.tableData = null;
                this.init();
            },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        init(){
            this.loading = true
            this.$axiosc.get('backstage/banner/list',{params:{type:parseInt(this.tab)}}).then(res=>{
                this.loading = false
                if(res.code == 200){
                    this.tableData = res.data
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //预览
        preview:function(row){
            this.logoPic = row.frontPath + row.bannerImgUrl
            this.dialogVisible=true;
        },

        //上移
        // moveTop:function(row){
            
        // },
        //下移
        moveDown:function(row,val){
            this.move.id = row.id
            this.move.move = val
            this.$axiosc.put('backstage/banner/moveUpDown',this.$qs.stringify(this.move)).then(res=>{
                if(res.code == 200){
                    this.init()
                    this.$message({
                        type: 'success',
                        message: val == 0?'上移成功':'下移成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        },
        //编辑
        edit:function(row){
            if(row) this.$router.push({path:`/systemLayout/bannerEdit/${this.tab}/${row.id}`,query:{index:'/systemLayout/banner'},params:{id:row.id,type:this.tab}});   
            else  this.$router.push({path:`/systemLayout/bannerEdit/${this.tab}`,query:{index:'/systemLayout/banner'}});   
            // this.$router.push({path:`/systemLayout/bannerEdit/${this.tab}/${row.id}`,query:{index:'/systemLayout/banner',linkPoint:row.linkPoint,bannerName:row.bannerName,bannerImgUrl:row.bannerImgUrl,linkType:row.linkType,linkUrl:row.linkUrl},params:{id:row.id,type:this.tab}});   
            
        },
        //删除
        del:function(row){
            this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.delete('backstage/banner/del/'+row.id).then(res=>{
                        if(res.code == 200){
                            this.init()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                    
            }).catch(() => {});
        },
    }
}
</script>

<style lang="scss" scoped>
.retrieve{
  flex-direction: row;
  .right{
    margin-top:0;
    margin-right:20px;
  }
}
</style>